// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b2b-lib-overlay{display:block;background:rgba(0,0,0,0.5);position:absolute;z-index:2;left:0;width:100%;overflow:hidden;height:100vh;top:0}\n", ""]);
// Exports
exports.locals = {
	"overlay": "b2b-lib-overlay"
};
module.exports = exports;
